// FE-PINV-064 — Pipeline-tab filter state.
//
// The Pipeline tab's new redesigned surface (Grid / Kanban / List)
// shares one filter shape across all three views. This is a distinct
// type from the v1 RenewalBoard's BoardFilters: the redesign drops
// preset-driven shapes and tag/industry filters in favor of the
// horizontal toolbar's 7-facet set + a global ``show_closed`` view
// affordance and ``density`` density.
//
// Keys mirror BE-PINV-061's ``filters_json`` schema and BE-PINV-062's
// filter-count endpoint params one-for-one. Renewal-window is a
// single-select (semantically a window choice, not a multi-select).

export type PipelineCadence =
  | "critical"
  | "behind"
  | "on_track"
  | "ahead"
  | "not_yet_urgent";


export type PipelineStage =
  | "lead"
  | "meeting_set"
  | "qualified"
  | "proposal"
  | "negotiation"
  | "bor_signed_pending_effective_date"
  | "closed_won"
  | "closed_lost";


export type PipelineLivesBand =
  | "micro"
  | "small"
  | "mid_market"
  | "large"
  | "enterprise";


export type PipelineOppType =
  | "new_business"
  | "bor_takeover"
  | "rfp_response"
  | "expansion";


export type PipelineRenewalWindow =
  | "this_month"
  | "next_30d"
  | "next_60d"
  | "next_90d"
  | "this_quarter"
  | "next_quarter";


export interface PipelineFilters {
  cadence: PipelineCadence[];
  stage: PipelineStage[];
  lives_band: PipelineLivesBand[];
  renewal_window: PipelineRenewalWindow | null;
  opportunity_type: PipelineOppType[];
  producer: string[];
  alerts_only: boolean;
}


export const EMPTY_PIPELINE_FILTERS: PipelineFilters = {
  cadence: [],
  stage: [],
  lives_band: [],
  renewal_window: null,
  opportunity_type: [],
  producer: [],
  alerts_only: false,
};


export type PipelineFacetKey = keyof PipelineFilters;


export type Density = "comfortable" | "compact";


export function isFiltersEmpty(f: PipelineFilters): boolean {
  return (
    f.cadence.length === 0
    && f.stage.length === 0
    && f.lives_band.length === 0
    && f.renewal_window === null
    && f.opportunity_type.length === 0
    && f.producer.length === 0
    && !f.alerts_only
  );
}


export function activeFacetCount(f: PipelineFilters): number {
  let n = 0;
  if (f.cadence.length > 0) n += 1;
  if (f.stage.length > 0) n += 1;
  if (f.lives_band.length > 0) n += 1;
  if (f.renewal_window !== null) n += 1;
  if (f.opportunity_type.length > 0) n += 1;
  if (f.producer.length > 0) n += 1;
  if (f.alerts_only) n += 1;
  return n;
}
